import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';
import { EModelName } from './model-name';

const LLMLogsSchema = new mongoose.Schema({
  user: {
    type: mongoose.Schema.Types.ObjectId,
    required: false,
    ref: EModelName.USER,
  },
  serviceName: { type: String },
  promptTokenCount: { type: Number },
  responseTokenCount: { type: Number },
  totalTokenCount: { type: Number },
  thinkingTokenCount: { type: Number },
  cachedTokenCount: { type: Number },
  modelName: { type: String },
  llmProvider: { type: String },
  created: { type: Date, default: Date.now },
});

export type T_LLMLogsBase = InferSchemaType<typeof LLMLogsSchema>;

// Add specific type information for meeting tool and type
export interface T_LLMLogs extends Omit<T_LLMLogsBase, 'created' | 'llmProvider'> {
  _id: string;
  llmProvider: 'openai' | 'gemini';
}

export type LLMLogsCreateDto = Required<Omit<T_LLMLogs, '_id' | 'created'>>;

export type T_LLMLogsSchemaDocument = T_LLMLogs &
  Document;

export { LLMLogsSchema };
